import type {
  AnalyticsRange,
  AnalyticsRangeKey,
  AnalyticsRangeSelection,
} from './types';
export const ANALYTICS_RANGE_LABELS: Record<AnalyticsRangeKey, string> = {
  today: 'Today',
  yesterday: 'Yesterday',
  '24h': 'Last 24 hours',
  '7d': 'Last 7 days',
  '30d': 'Last 30 days',
  '90d': 'Last 90 days',
  month: 'Month to date',
  'last-month': 'Last month',
  year: 'Year to date',
  '12mo': 'Last 12 months',
  all: 'All time',
  custom: 'Custom range',
};
export type AnalyticsRangeInput =
  AnalyticsRangeKey | AnalyticsRangeSelection | AnalyticsRange;
export const analyticsRangeParams = (
  input: AnalyticsRangeInput,
): URLSearchParams => {
  const range = typeof input === 'string' ? { key: input } : input;
  const query = new URLSearchParams({ range: range.key });
  if ('end' in range) {
    query.set('end', range.anchor ?? range.end);
    if (range.key === 'custom') {
      query.set('from', range.start.slice(0, 10));
      query.set(
        'to',
        new Date(Math.max(Date.parse(range.start), Date.parse(range.end) - 1))
          .toISOString()
          .slice(0, 10),
      );
    }
  } else {
    if (range.from) {
      query.set('from', range.from);
    }
    if (range.to) {
      query.set('to', range.to);
    }
  }
  return query;
};
export const analyticsRangeLabel = (input: AnalyticsRangeInput): string => {
  const range = typeof input === 'string' ? { key: input } : input;
  if (range.key !== 'custom') {
    return ANALYTICS_RANGE_LABELS[range.key];
  }
  const params = analyticsRangeParams(range);
  const format = (date: string) =>
    new Intl.DateTimeFormat('en', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(new Date(`${date}T00:00:00Z`));
  const from = params.get('from'),
    to = params.get('to');
  return from && to ? `${format(from)} – ${format(to)}` : 'Custom range';
};
